import React from 'react';
import logoImg from '../Assets/Asset 5@300x.png';

const go = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const NAV_COLS = [
    {
        title: 'Navigate',
        links: [
            { l: 'Home',         id: 'home' },
            { l: 'About Us',     id: 'about' },
            { l: 'Our Services', id: 'services' },
            { l: 'Our Partners', id: 'partners' },
            { l: 'Contact Us',   id: 'contact' },
        ],
    },
    {
        title: 'Properties',
        links: [
            { l: 'For Sale',             id: 'sale' },
            { l: 'For Rent',             id: 'rent' },
            { l: 'Property Management',  id: 'services' },
            { l: 'Investment Advisory',  id: 'services' },
            { l: 'Valuation Services',   id: 'services' },
        ],
    },
];


const Footer: React.FC = () => (
    <>
        <style>{`
      /* ══════════════════════════════════════
         FOOTER  —  always dark navy #030024
         ══════════════════════════════════════ */
      .footer {
        background: #030024;
        position: relative;
        overflow: hidden;
      }

      .footer-accent {
        height: 1px;
        background: linear-gradient(90deg,
          transparent 0%,
          rgba(240,194,119,0.6) 30%,
          rgba(102,172,161,0.6) 60%,
          transparent 100%);
      }

      .footer-glow {
        position: absolute;
        top: 0; left: -10%; right: -10%;
        height: 300px;
        background: radial-gradient(ellipse 60% 100% at 50% 0%,
          rgba(102,172,161,0.07) 0%, transparent 70%);
        pointer-events: none;
      }

      /* ─── CTA banner ─── */
      .footer-cta {
        position: relative; z-index: 1;
        border-bottom: 1px solid rgba(102,172,161,0.1);
        padding: 3.5rem 2.5rem;
        max-width: 1300px; margin: 0 auto;
        display: flex; align-items: center;
        justify-content: space-between; gap: 2rem; flex-wrap: wrap;
      }
      .footer-cta-tag {
        font-family: 'Tenor Sans', sans-serif;
        font-size: 0.56rem; letter-spacing: 0.38em; text-transform: uppercase;
        color: #66ACA1; margin-bottom: 0.7rem;
        display: flex; align-items: center; gap: 0.8rem;
      }
      .footer-cta-tag::before {
        content: ''; display: block; width: 24px; height: 1px; background: #66ACA1;
      }
      .footer-cta-h {
        font-family: 'Cormorant Garamond', Georgia, serif;
        font-size: clamp(1.6rem, 3vw, 2.4rem);
        font-weight: 300; color: #F8F5EF; line-height: 1.2;
      }
      .footer-cta-h em {
        font-style: italic; color: #F0C277; font-weight: 400;
      }
      .footer-cta-btn {
        font-family: 'Tenor Sans', sans-serif;
        font-size: 0.65rem; font-weight: 600; letter-spacing: 0.2em;
        text-transform: uppercase; color: #030024;
        background: #F0C277; padding: 14px 32px;
        border: none; border-radius: 3px; cursor: pointer;
        transition: background 0.28s, transform 0.22s, box-shadow 0.28s;
        white-space: nowrap; flex-shrink: 0;
      }
      .footer-cta-btn:hover {
        background: #d9a85a;
        transform: translateY(-2px);
        box-shadow: 0 12px 32px rgba(240,194,119,0.3);
      }

      /* ─── Main grid ─── */
      .footer-main {
        position: relative; z-index: 1;
        max-width: 1300px; margin: 0 auto;
        padding: 3.5rem 2.5rem 2.5rem;
        display: grid;
        grid-template-columns: 1.8fr 1fr 1fr 1.1fr;
        gap: 3rem;
        border-bottom: 1px solid rgba(102,172,161,0.08);
      }

      /* Brand col */
      .ft-logo {
        height: 52px; width: auto; object-fit: contain;
        display: block; margin-bottom: 1.4rem;
        filter: brightness(1.05);
      }
      .ft-tagline {
        font-family: 'Cormorant Garamond', Georgia, serif;
        font-size: 1rem; font-style: italic; font-weight: 300;
        color: rgba(248,245,239,0.3); line-height: 1.6; margin-bottom: 1.8rem;
      }
      .ft-desc {
        font-family: 'Montserrat', sans-serif;
        font-size: 0.72rem; font-weight: 300; line-height: 1.9;
        color: rgba(248,245,239,0.28); margin-bottom: 1.8rem;
        letter-spacing: 0.02em;
      }

      /* ─── Social icons ─── */
      .ft-socials {
        display: flex; gap: 0.6rem;
      }
      .ft-soc {
        width: 36px; height: 36px;
        border: 1px solid rgba(102,172,161,0.2); border-radius: 6px;
        display: flex; align-items: center; justify-content: center;
        color: rgba(248,245,239,0.35);
        background: rgba(255,255,255,0.03);
        cursor: pointer; text-decoration: none;
        transition: border-color 0.28s, color 0.28s, background 0.28s, transform 0.22s, box-shadow 0.28s;
        flex-shrink: 0;
      }
      .ft-soc:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.3);
      }
      .ft-soc.fb:hover  { color: #1877F2; border-color: #1877F2; background: rgba(24,119,242,0.1); }
      .ft-soc.ig:hover  { color: #E1306C; border-color: #E1306C; background: rgba(225,48,108,0.1); }
      .ft-soc.li:hover  { color: #0A66C2; border-color: #0A66C2; background: rgba(10,102,194,0.1); }
      .ft-soc.yt:hover  { color: #FF0000; border-color: #FF0000; background: rgba(255,0,0,0.1); }
      .ft-soc.yt:hover svg path:first-child { fill: #FF0000; }
      .ft-soc.yt:hover svg polygon { fill: #fff; }

      /* Link cols */
      .ft-col-title {
        font-family: 'Tenor Sans', sans-serif;
        font-size: 0.55rem; letter-spacing: 0.32em; text-transform: uppercase;
        color: #F0C277; margin-bottom: 1.4rem;
        display: flex; align-items: center; gap: 0.7rem;
      }
      .ft-col-title::after {
        content: ''; flex: 1; height: 1px;
        background: rgba(240,194,119,0.15);
      }
      .ft-list { list-style: none; display: flex; flex-direction: column; gap: 0.7rem; }
      .ft-list-btn {
        font-family: 'Montserrat', sans-serif;
        font-size: 0.73rem; font-weight: 300; letter-spacing: 0.03em;
        color: rgba(248,245,239,0.32); background: none; border: none;
        text-align: left; padding: 0; cursor: pointer;
        transition: color 0.25s, padding-left 0.25s;
        display: flex; align-items: center; gap: 0.5rem;
      }
      .ft-list-btn::before {
        content: ''; width: 0; height: 1px; background: #66ACA1;
        transition: width 0.25s; flex-shrink: 0;
      }
      .ft-list-btn:hover { color: rgba(248,245,239,0.85); }
      .ft-list-btn:hover::before { width: 14px; }

      /* Contact col */
      .ft-contact-item {
        display: flex; align-items: flex-start; gap: 0.9rem;
        margin-bottom: 1rem; padding-bottom: 1rem;
        border-bottom: 1px solid rgba(102,172,161,0.07);
      }
      .ft-contact-item:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; }
      .ft-ci-icon {
        width: 28px; height: 28px; border-radius: 3px;
        border: 1px solid rgba(102,172,161,0.18);
        display: flex; align-items: center; justify-content: center;
        font-size: 0.75rem; color: #66ACA1; flex-shrink: 0;
        background: rgba(102,172,161,0.05);
      }
      .ft-ci-lbl {
        font-family: 'Tenor Sans', sans-serif;
        font-size: 0.5rem; letter-spacing: 0.24em; text-transform: uppercase;
        color: rgba(102,172,161,0.7); margin-bottom: 2px;
      }
      .ft-ci-val {
        font-family: 'Montserrat', sans-serif;
        font-size: 0.71rem; font-weight: 300;
        color: rgba(248,245,239,0.4); letter-spacing: 0.02em;
      }

      /* ─── RERA strip ─── */
      .footer-rera {
        position: relative; z-index: 1;
        max-width: 1300px; margin: 0 auto;
        padding: 1.4rem 2.5rem;
        display: flex; align-items: center; gap: 1.5rem; flex-wrap: wrap;
        border-bottom: 1px solid rgba(102,172,161,0.06);
      }
      .ft-rera-badge {
        font-family: 'Tenor Sans', sans-serif;
        font-size: 0.52rem; letter-spacing: 0.22em; text-transform: uppercase;
        color: rgba(240,194,119,0.45); border: 1px solid rgba(240,194,119,0.18);
        padding: 5px 12px; border-radius: 2px;
      }
      .ft-rera-sep { width: 1px; height: 14px; background: rgba(102,172,161,0.2); }
      .ft-rera-text {
        font-family: 'Montserrat', sans-serif;
        font-size: 0.65rem; font-weight: 300;
        color: rgba(248,245,239,0.18); letter-spacing: 0.03em;
      }

      /* ─── Bottom bar ─── */
      .footer-bottom {
        position: relative; z-index: 1;
        max-width: 1300px; margin: 0 auto;
        padding: 1.4rem 2.5rem;
        display: flex; align-items: center;
        justify-content: space-between; gap: 1rem; flex-wrap: wrap;
      }
      .ft-copy {
        font-family: 'Montserrat', sans-serif;
        font-size: 0.67rem; font-weight: 300;
        color: rgba(248,245,239,0.15); letter-spacing: 0.04em;
      }
      .ft-legal { display: flex; gap: 1.6rem; flex-wrap: wrap; }
      .ft-legal-btn {
        font-family: 'Montserrat', sans-serif;
        font-size: 0.65rem; font-weight: 300;
        color: rgba(248,245,239,0.2); background: none; border: none;
        cursor: pointer; padding: 0; transition: color 0.25s;
      }
      .ft-legal-btn:hover { color: #66ACA1; }

      /* ── Responsive ── */
      @media (max-width: 1100px) {
        .footer-main { grid-template-columns: 1fr 1fr; gap: 2.5rem; }
      }
      @media (max-width: 700px) {
        .footer-cta { padding: 2.5rem 1.5rem; flex-direction: column; align-items: flex-start; }
        .footer-main { grid-template-columns: 1fr; padding: 2.5rem 1.5rem; }
        .footer-rera { padding: 1.2rem 1.5rem; }
        .footer-bottom { padding: 1.2rem 1.5rem; flex-direction: column; align-items: flex-start; gap: 0.7rem; }
        .ft-legal { gap: 1rem; }
      }
    `}</style>

        <footer className="footer">
            <div className="footer-accent" />
            <div className="footer-glow" />

            {/* CTA Banner */}
            <div className="footer-cta">
                <div>
                    <p className="footer-cta-tag">Ready to Begin</p>
                    <h3 className="footer-cta-h">
                        Find Your Perfect <em>Property</em> in UAE
                    </h3>
                </div>
                <button className="footer-cta-btn" onClick={() => go('contact')}>
                    Get a Free Consultation ↗
                </button>
            </div>

            {/* Main 4-col grid */}
            <div className="footer-main">

                {/* Brand */}
                <div>
                    <img src={logoImg} alt="Burj Al Arab Real Estate" className="ft-logo" />
                    <p className="ft-tagline">"Where Property Becomes Prosperity."</p>
                    <p className="ft-desc">
                        A trusted and value-driven real estate partner across the UAE — recognised for
                        professional standards and transparent dealings.
                    </p>
                    <div className="ft-socials">
                        <a href="https://facebook.com/profile.php?id=61589404691044" target="_blank" rel="noopener noreferrer" className="ft-soc fb" title="Facebook">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                            </svg>
                        </a>
                        <a href="https://instagram.com/burjalarabrealestateuae" target="_blank" rel="noopener noreferrer" className="ft-soc ig" title="Instagram">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                            </svg>
                        </a>
                        <a href="https://linkedin.com/company/burj-al-arab-real-estate" target="_blank" rel="noopener noreferrer" className="ft-soc li" title="LinkedIn">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                                <rect x="2" y="9" width="4" height="12"/>
                                <circle cx="4" cy="4" r="2"/>
                            </svg>
                        </a>
                        <a href="https://www.youtube.com/@BurjAlArabRealEstateUAE" target="_blank" rel="noopener noreferrer" className="ft-soc yt" title="YouTube">
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                                <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#030024"/>
                            </svg>
                        </a>
                    </div>
                </div>

                {/* Nav + Properties cols */}
                {NAV_COLS.map(col => (
                    <div key={col.title}>
                        <p className="ft-col-title">{col.title}</p>
                        <ul className="ft-list">
                            {col.links.map(item => (
                                <li key={item.l}>
                                    <button className="ft-list-btn" onClick={() => go(item.id)}>
                                        {item.l}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}

                {/* Contact */}
                <div>
                    <p className="ft-col-title">Contact</p>
                    {[
                        { icon: '↩', lbl: 'Phone',  val: '+971 547 818 839' },
                        { icon: '@', lbl: 'Email',  val: 'info@burjalarab-realestate.com' },
                        { icon: '◎', lbl: 'Office', val: 'Ajman, Nakheel 01, United Arab Emirates' },
                        {
                            icon: '◷',
                            lbl: 'Hours',
                            hours: [
                                { day: 'Mon – Fri', time: '9:00 AM – 6:00 PM' },
                                { day: 'Saturday',  time: '9:00 AM – 1:00 PM' },
                                { day: 'Sunday',    time: 'Closed'             },
                            ]
                        },
                    ].map(c => (
                        <div key={c.lbl} className="ft-contact-item">
                            <div className="ft-ci-icon">{c.icon}</div>
                            <div>
                                <p className="ft-ci-lbl">{c.lbl}</p>
                                {c.hours ? (
                                    c.hours.map(h => (
                                        <p key={h.day} className="ft-ci-val">
                                            <span style={{ minWidth: '72px', display: 'inline-block' }}>{h.day}:</span>
                                            {h.time}
                                        </p>
                                    ))
                                ) : (
                                    <p className="ft-ci-val">{c.val}</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/*/!* RERA strip *!/*/}
            {/*<div className="footer-rera">*/}
            {/*    <span className="ft-rera-badge">RERA Registered</span>*/}
            {/*    <div className="ft-rera-sep" />*/}
            {/*    <span className="ft-rera-badge">DLD Approved</span>*/}
            {/*    <div className="ft-rera-sep" />*/}
            {/*    <span className="ft-rera-text">*/}
            {/*        Burj Al Arab Real Estate LLC — Licensed by the Real Estate Regulatory Agency, Dubai*/}
            {/*    </span>*/}
            {/*</div>*/}

            {/* Bottom bar */}
            <div className="footer-bottom">
                <p className="ft-copy">
                    © {new Date().getFullYear()} Burj Al Arab Real Estate. All rights reserved.
                </p>
                <div className="ft-legal">
                    {['Privacy Policy', 'Terms of Service', 'RERA Compliance', 'Cookie Policy'].map(l => (
                        <button key={l} className="ft-legal-btn">{l}</button>
                    ))}
                </div>
            </div>
        </footer>
    </>
);

export default Footer;